<template>
  <div class="tabs text-center">
    <div class="accordion" id="accordionExample">
      <div class="card">
        <div class="card-header" id="headingOne">
          <h5 class="mb-0 float-left">
            <button class="btn btn-link" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
              <img src="~@/assets/story/images/noun_organization_201598.png" alt="Logo" class="logo-img"/> Organization
            </button>
          </h5>
        </div>

        <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
          <div class="card-body">
            <template v-for="item in organizationListSideBar">
              <div class="form-check">
                <input
                  @change="organizationFilterSideBar(item)"
                  class="form-check-input"
                  type="checkbox"
                  name="flexRadioDefault"
                  v-model="item.checked"
                />
                <label class="form-check-label" for="flexRadioDefault1">
                  {{ item.name }}
                </label>
              </div>
            </template>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-header" id="headingTwo">
          <h5 class="mb-0 float-left">
            <button class="btn btn-link collapsed" type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
              <img src="~@/assets/story/images/noun_User_3680417.png" alt="Logo" class="logo-img"/> Author
            </button>
          </h5>
        </div>
        <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionExample">
          <div class="card-body">
            <div
              class="form-check" v-for="user in finalAuthorsSideBar"
                    :key="user.name">
              <input
                class="form-check-input"
                type="checkbox"
                name="author"
                :id="user.name"
                v-model="user.checked"
                @change="update(user)"
              />
              <label class="form-check-label" for="Amir">
                {{ user.name }}
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-header" id="headingThree">
          <h5 class="mb-0 float-left">
            <button class="btn btn-link collapsed" type="button" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
              <img src="~@/assets/story/images/Group-33.png" alt="Logo" class="logo-img"/> Experience
            </button>
          </h5>
        </div>
        <div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordionExample">
          <div class="card-body">
            <div class="form-check" v-for="experience in experienceFilterSideBar">
              <input
                class="form-check-input"
                type="checkbox"
                v-model="experience.checked"
                @change="searchExperienceFilterSideBar(experience)"
                id="flexCheckDefault"
              />
              <label class="form-check-label" for="flexCheckDefault">
                {{ experience.name }}
              </label>
            </div>
          </div>
        </div>
      </div>
      <!-- Starred list menu item -->
       <div class="card">
        <div class="card-header" id="headingThree">
       <h5 class="mb-0 float-left" v-if="isStarred">     
     <button class="btn btn-link collapsed" type="button" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree"><a @click.stop="displayStarred()"><i class="far fa-star" aria-hidden="true"></i>&nbsp;Starred</a></button>
       </h5>
        <h5 class="mb-0 float-left" v-if="!isStarred">
     <button class="btn btn-link collapsed" type="button" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree"><a @click.stop="displayStarred()"><i class="fa fa-star" aria-hidden="true"></i>&nbsp;Starred</a></button>
        </h5>

        </div>
      </div>
      <!-- Starred list menu item -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'sideBarFilters',
  components: {},
  data: () => ({
    isStarred:true,
    searchAuthorName: null,
    selectAllAuthorsSideBar: false,
    allOrganizationSelectSideBar: false,
    searchOrganizationsName: '',
    text: null,
    value: null,
    authorsSideBar: [],
    finalAuthorsSideBar: [],
    experienceFilterSideBar: [
      {
        name: 'AR',
        checked: false
      },
      {
        name: 'VR',
        checked: false
      },
      {
        name: 'Screen',
        checked: false
      }
    ],
    allExperienceSelectedSideBar: false,
    // experienceSearch: '',
    props: ['search'],
    showModal: false,
    objectItems: {
      key1: 'item1',
      key2: 'item2',
      key3: 'item3'
    },
    organizationListSideBar: []
  }),
  mounted: function () {
    let _this = this
    setTimeout(function () {
      _this.toggleMenu()
    }, 2000)
  },
  methods: {
    searchAuthors: function () {
      this.finalAuthorsSideBar = []
      if (this.searchAuthorName.length === 0) {
        for (const authorsKey in this.authorsSideBar) {
          this.finalAuthorsSideBar.push({
            name:
              this.authorsSideBar[authorsKey].charAt(0).toUpperCase() +
              this.authorsSideBar[authorsKey].slice(1),
            checked: false
          })
        }
        return
      }
      this.authorsSideBar.filter((value) => {
        if (value.startsWith(this.searchAuthorName.toLowerCase())) {
          this.finalAuthorsSideBar.push({
            name: value.charAt(0).toUpperCase() + value.slice(1),
            checked: false
          })
        }
      })
    },
    update: function (user) {
      let breadCrumb = {}
      if (user.name === 'Custom') {
        this.showModal = true
      } else {
        breadCrumb.step1 = 'Author'
        for (const finalAuthorsKey in this.finalAuthorsSideBar) {
          if (user === 'All') {
            this.finalAuthorsSideBar[finalAuthorsKey].checked = this.selectAllAuthorsSideBar
          }
          if (user.checked) {
            if (user.name !== this.finalAuthorsSideBar[finalAuthorsKey].name) {
              this.finalAuthorsSideBar[finalAuthorsKey].checked = false
            }
          }
        }
        let checkedCount = 0
        let key = 0
        for (const finalAuthorsKey in this.finalAuthorsSideBar) {
          if (this.finalAuthorsSideBar[finalAuthorsKey].checked === true) {
            checkedCount = checkedCount + 1
            key = this.finalAuthorsSideBar[finalAuthorsKey].name
          }
          if ((this.finalAuthorsSideBar.length - checkedCount) === (this.finalAuthorsSideBar.length - 1)) {
            breadCrumb.step2 = key
          } else {
            breadCrumb.step2 = ''
          }
        }
      }
      this.organizationListSideBar.map(value => { value.checked = false })
      this.experienceFilterSideBar.map(value => { value.checked = false })
      this.$parent.authorSideBar = this.finalAuthorsSideBar
      this.$parent.breadCrumbs = breadCrumb
    },
    toggleMenu: function () {
      const data = this.$store.state.stories
      let orgListSideBar = []
      this.organizationListSideBar = []
      for (const property in data) {
        if (
          data[property].hasOwnProperty('author') &&
          !data[property].author.includes('@') &&
          !this.authorsSideBar.includes(data[property].author.toLocaleLowerCase())
        ) {
          this.authorsSideBar.push(data[property].author.toLocaleLowerCase())
          this.finalAuthorsSideBar.push({
            name: data[property].author,
            checked: false
          })
        }
        if (data[property].hasOwnProperty('organization') && data[property].organization) {
          orgListSideBar.push({
            'name': data[property].organization.charAt(0).toUpperCase() + data[property].organization.slice(1),
            'checked': false
          })
        }
        this.organizationListSideBar = orgListSideBar
      }
    },
    organizationFilterSideBar (org) {
      let breadCrumb = {}
      breadCrumb.step1 = 'Organization'
      if (org === 'All') {
        this.organizationListSideBar = this.organizationListSideBar.map(value => {
          value.checked = this.allOrganizationSelectSideBar
          return value
        })
      }
      if (org.checked) {
        breadCrumb.step2 = org.name
        for (const orgKey in this.organizationListSideBar) {
          if (org.name !== this.organizationListSideBar[orgKey].name) {
            this.organizationListSideBar[orgKey].checked = false
          }
        }
      } else {
        let checkedCount = 0
        let key = 0
        for (const orgKey in this.organizationListSideBar) {
          if (this.organizationListSideBar[orgKey].checked === true) {
            checkedCount = checkedCount + 1
            key = this.organizationListSideBar[orgKey].name
          }
        }
        if ((this.organizationListSideBar.length - checkedCount) === (this.organizationListSideBar.length - 1)) {
          breadCrumb.step2 = key
        }
      }
      this.finalAuthorsSideBar.map(value => { value.checked = false })
      this.experienceFilterSideBar.map(value => { value.checked = false })
      this.$parent.organizationsSideBar = this.organizationListSideBar
      this.$parent.breadCrumbs = breadCrumb
    },
    searchOrganizations () {
      this.organizationListSideBar = []
      if (!this.searchOrganizationsName.length) {
        this.$store.state.stories.map(value => {
          if (value.hasOwnProperty('organization') && value.organization) {
            this.organizationListSideBar.push({
              name: value.organization.charAt(0).toUpperCase() + value.organization.slice(1),
              checked: false
            })
          }
        })
        return
      }
      let list = this.$store.state.stories
      for (const listKey in list) {
        if (list[listKey].hasOwnProperty('organization') && list[listKey].organization && list[listKey].organization.toLowerCase().startsWith(this.searchOrganizationsName.toLowerCase())) {
          this.organizationListSideBar.push({
            name: list[listKey].organization.charAt(0).toUpperCase() + list[listKey].organization.slice(1),
            checked: false
          })
        }
      }
    },
    searchExperienceFilterSideBar (data) {
      let breadCrumb = {}
      breadCrumb.step1 = 'Experience'
      if (data === 'all') {
        this.experienceFilterSideBar = this.experienceFilterSideBar.map(value => {
          value.checked = this.allExperienceSelectedSideBar
          return value
        })
      }
      if (data.checked) {
        breadCrumb.step2 = data.name
        for (const expKey in this.experienceFilterSideBar) {
          if (data.name !== this.experienceFilterSideBar[expKey].name) {
            this.experienceFilterSideBar[expKey].checked = false
          }
        }
      } else {
        let checkedCount = 0
        let key = 0
        for (const expKey in this.experienceFilterSideBar) {
          if (this.experienceFilterSideBar[expKey].checked === true) {
            checkedCount = checkedCount + 1
            key = this.experienceFilterSideBar[expKey].name
          }
        }
        if ((this.experienceFilterSideBar.length - checkedCount) === (this.experienceFilterSideBar.length - 1)) {
          breadCrumb.step2 = key
        }
      }
      this.organizationListSideBar.map(value => { value.checked = false })
      this.finalAuthorsSideBar.map(value => { value.checked = false })
      this.$emit('searchExperienceFilterSideBar', this.experienceFilterSideBar)
      this.organizationListSideBar.map(value => {value.checked = false});
      this.finalAuthorsSideBar.map(value => {value.checked = false});
    },
    displayStarred() {
    if(this.isStarred){
    this.$emit('displayStarred', 'starred')
    this.isStarred = false
    }
    else{
    this.$emit('displayStarred', '')
    this.isStarred = true
    }
      this.$parent.breadCrumbs = breadCrumb
    },
  }
}
</script>

<style scoped>
body {
  margin: 0;
}

.starred{
  height: 50px;
  margin-top:20px;
  float: left;
}
.starred a{
  margin-left:2px;
  float: left;
}


.btn:hover {
  background-color: none;
}

.btn.active {
  background-color: #666;
  color: white;
}

#modal-1 label {
  float: left;
  padding: 0px 2px;
  width: 100px;
}

#modal-1 input {
  float: left;
  padding: 0px 50px;
  width: 300px;
  background-color: #e0e0e0;
}

#modal-5 label {
  float: left;
  padding: 0px 2px;
  width: 200px;
}

#modal-5 select {
  float: left;
  padding: 0px 50px;
  width: 200px;
  border: 1px solid #c6c6c6;
}

#modal-4 label {
  float: left;
  padding: 0px 2px;
}

#modal-4 input {
  width: 200px;
  float: left;
  height: 22px;
  background-color: #e0e0e0;
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.circles {
  height: 60px;
  width: 100px;
  margin: 0px 20px 0px 20px;
}

.circle {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  border: 1px solid;
  background-color: #f8904a;
  float: left;
  margin: 2px 4px 6px 6px;
}

.assets {
  width: 100%;
  float: left;
  display: none;
}

#assets {
  display: none;
}

.assets span {
  margin: 14px 0px 5px 10px;
  float: left;
  color: #000;
}

.radioGroup {
  margin-top: 10px;
}

.dropbtn {
  border: none;
}

.dropup {
  position: relative;
  display: inline-block;
}

.dropup-content {
  display: none;
  position: absolute;
  background-color: #fff;
  min-width: 160px;
  top: 25px;
  z-index: 1;
  left: 0px;
  height: 250px;
  overflow-y: scroll;
  border: 1px solid #cecece;
  padding: 10px 10px;
  font-family: Exo, sans-serif;
  font-size: 12px;
  color: #000;
}

.dropup-content input[type="text"] {
  border: 1px none #000;
  background-color: #e0e0e0;
  font-size: 9px;
}

.dropup-content a {
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}

.dropup-content a:hover {
  background-color: #fff;
}

.dropup:hover .dropup-content {
  display: block;
}

.dropup:hover .dropbtn {
  background-color: none;
}

.icon-bar {
  width: 100%;
  overflow: auto;
}

.right-top {
  float: right;
  margin-top: -30px;
}

.right-top a {
  margin: 0px 2px 2px 2px;
  text-align: center;
  font-size: 15px;
  font-weight: none;
  color: #000;
  text-decoration: none;
}

.btn-group {
  font-size: 13px !important;
}

.icon-bar img {
  margin: 0px 2px 2px 2px;
  width: 20px;
}

.icon-bar a {
  float: left;
  margin-right: 10px;
  text-align: center;
  font-size: 20px;
  font-weight: none;
  color: #000;
}

.icon-bar a:hover {
  background-color: none;
}

.active {
  background-color: none;
}

.tabs {
  margin: 2px auto;
}

.navbar {
  display: none;
  font-family: Exo, sans-serif;
  color: #747474;
}

.navbar span {
  margin: 14px 0px 5px 10px;
  float: left;
}

.navbar img {
  margin: 0px 2px 5px 0px;
}

.navbar button {
  color: #000;
  text-decoration: none;
  font-size: 13px;
  padding: 2px 25px;
  font-family: Exo, sans-serif;
  color: #747474;
}

.navbar a {
  text-align: left;
  color: #000;
  text-decoration: none;
  font-size: 13px;
}

.radioGroup {
  text-align: left !important;
}

.navbar a:hover {
  background-color: none;
}

.active {
  background-color: none;
}

.tooltip {
  position: relative;
  display: inline-block;
  border-bottom: 1px dotted black; /* If you want dots under the hoverable text */
}

.dropdown-item i {
  opacity: 0.5;
  font-size: 80%;
}

.card-body{
  text-align: left;
}
</style>




// WEBPACK FOOTER //
// src/components/filters/sideBarFilters.vue